module.exports = __webpack_public_path__ + "static/media/Tawuniya-Logo-micro.05018039.svg";